import { useMutation } from "@/compat/reactQuery";
import auditService from "../../services/auditService";

const useReplaceAuditPDF = () =>
    useMutation(auditService.replacePdfForAudit)

export default useReplaceAuditPDF;